export function generateLabelFromCondition(condition?: string) {
  return condition
    ?.split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
